import { AwaitResponse } from '@general/js/utils/MockUtils';
import AbstractClass from './WaitingPeriodAbstractServices';

export default class WaitingPeriodServices extends AbstractClass {
  static getWaitingPeriodsReferenceData() {
    const mockData = {
      waitingPeriodsInformationText: {
        informationText:
          '<p>A waiting period applies when you first join Defence Health &ndash; or you&rsquo;ve had a break in cover of two months or more. You&rsquo;ll also need to serve a waiting period on new or higher benefits if you upgrade your cover (or reduce your excess). Learn more about waiting periods in <a href="https://www.defencehealth.com.au/Health-Insurance/Explore-Health-Cover/Waiting-periods">this article</a>, or in your product guide.<br />\r\n<br />\r\nThe policy holder and members with full access can view the waiting periods for all members (except if a member has &lsquo;keep private&rsquo; turned on).</p>\r\n',
      },
      waitingPeriodsCalloutText: {
        informationText: '<h3><strong>Make a claim</strong></h3>\r\n\r\n<p>If you&rsquo;ve served the relevant waiting period, you can make an extras claim online.</p>\r\n',
      },
      hospitalWaitingPeriodsInformationText: {
        informationText:
          '<h2>Hospital waiting periods</h2>\r\n\r\n<p>Most hospital waiting periods are two months. Some treatment categories have a 12-month waiting period.<br />\r\n<br />\r\nIf you&rsquo;ve held your current hospital cover for less than 12 months and need treatment, your condition may be deemed &lsquo;pre-existing&rsquo; and a 12-month waiting period could apply. Contact us before receiving hospital treatment to check if this rule applies.</p>\r\n', // h2
      },
      extrasWaitingPeriodsInformationText: {
        informationText: '<h2>Extras waiting periods</h2>\r\n', // h2
      },
    };
    return AwaitResponse(JSON.parse(JSON.stringify(mockData).tokenSwap()));
  }

  static getWaitingPeriods() {
    const mockData = {
      membersList: [
        {
          firstName: 'David',
          lastName: 'Benes',
          coveredOnMembership: 'Spouse', // Policy Holder, Spouse, Child etc.
          personCode: 'MEM-02',
          waitingPeriods: [
            {
              id: ['1'],
              servicesDescription: 'Assisted reproductive services', // This is new
              serviceType: 'C', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Gynaecology', // This is new
              serviceType: 'C', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Optical', // This is new
              serviceType: 'M',
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean',
            },
            {
              id: ['1'],
              servicesDescription: 'Myotherapy', // This is new
              serviceType: 'M',
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '', // This is new
              waived: 'boolean',
            },
            {
              id: ['1'],
              servicesDescription: 'Chiropractic', // This is new
              serviceType: 'M',
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: 'Served',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean',
            },
            {
              id: ['1'],
              servicesDescription: 'Myotherapy', // This is new
              serviceType: 'M',
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: 'Served', // This is new
              waived: 'boolean',
            },
          ],
        },
        {
          firstName: 'Elaine',
          lastName: 'Benes',
          coveredOnMembership: 'Policy Holder', // Policy Holder, Spouse, Child etc.
          personCode: 'MEM-01',
          waitingPeriods: [
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'M', // M = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'M', // M = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'M', // M = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'M', // M = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'M', // M = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'M', // M = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Bone, joint and muscle', // This is new
              serviceType: 'M', // M = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Acupuncture', // This is new
              serviceType: 'M', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Ambulance', // This is new
              serviceType: 'M', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'C', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 0,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'C', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'C', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'C', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'C', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'C', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'C', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Blood', // This is new
              serviceType: 'C', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Bone, joint and muscle', // This is new
              serviceType: 'C', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Acupuncture', // This is new
              serviceType: 'M', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Ambulance', // This is new
              serviceType: 'M', // C = Clinical Categories / Hospital products  AND M = Modalities / Extras Products
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean', // TO-DO REMOVE THIS FLAG SINCE ITS NOT USED BY CMS
            },
            {
              id: ['1'],
              servicesDescription: 'Brain and nervous system', // This is new
              serviceType: 'C',
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Adopted',
              served: false,
              periodEndDate: '',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean',
            },
            {
              id: ['1'],
              servicesDescription: 'Breast surgery (medically necessary)', // This is new
              serviceType: 'C',
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: '',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '', // This is new
              waived: 'boolean',
            },
            {
              id: ['1'],
              servicesDescription: 'Chemotherapy, radiotherapy and immunotherapy for cancer', // This is new
              serviceType: 'C',
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: 'Served',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: '2025-05-05', // This is new
              waived: 'boolean',
            },
            {
              id: ['1'],
              servicesDescription: 'Diabetes management (excluding insulin pumps)', // This is new
              serviceType: 'C',
              serviceOptionServiceCode: 'EXT_BLGLU',
              waiverReason: 'Reason for waiver',
              served: false,
              periodEndDate: '2024-11-06',
              lengthOfWait: 6,
              preWaitPeriodLength: 8, // This is new
              preWaitPeriodEndDate: 'Served', // This is new
              waived: 'boolean',
            },
          ],
        },
      ],
    };
    return AwaitResponse(JSON.parse(JSON.stringify(mockData)));
  }
}
